import {
  required,
  email,
  cpf,
  cpf_cnpj,
  cnpj,
  validateNumberInt,
  validateNumberInt16,
  validateNumberTinyInt,
  validatePercentage,
  validatePercentageWithoutNegative,
  validateIntegerPositive,
  validateIntegerNegative,
  validateNegativeValue,
  validatePositiveValue,
  validatePercentageLessThan100,
  validateTextWithoutSpecialCharacters
} from '@/helpers/validations';
import { compileDynamicString } from '@/helpers/page';

const rulesMixin = {
  data() {
    return {
      min : v => {
        if (v === null || v === undefined || v === '' || v.length === 0) return true;
      
        if (v.length < this.schema.min)
          return `Minimo ${this.schema.min} Caracteres!`;
      
        return true;
      },
      max: v => {
        if (v === null || v === undefined || v === '' || v.length === 0) return true;

        if (v.length > this.schema.max)
          return `Máximo ${this.schema.max} Caracteres!`;
      
        return true;
      },
      numberRange: v => {
        if (v === null || v === undefined || v === '' || v.length === 0) return true;

        let rangeMin = compileDynamicString({ page: this.formOptions.page, mode: this.formOptions.mode, originalString: this.schema.rangeMin, index: this.formOptions?.index });
        let rangeMax = compileDynamicString({ page: this.formOptions.page, mode: this.formOptions.mode, originalString: this.schema.rangeMax, index: this.formOptions?.index });
        let rangeErrorMessage = ('rangeErrorMessage' in this.schema) && compileDynamicString({ page: this.formOptions.page, mode: this.formOptions.mode, originalString: this.schema.rangeErrorMessage, index: this.formOptions?.index });

        const returnMsgValidateRange = {
          'minAndMax':  'O número deve estar entre ' + rangeMin + ' e ' + rangeMax,
          'min': 'O número minimo aceito é ' + rangeMin,
          'max': 'O número máximo aceito é ' + rangeMax
        }

        // Pre-formata o valor digitado nos inputs decimais
        let c1 = String(3 / 2).charAt(1);
        let c2 = '';

        if (c1 === '.') {
          c2 = ',';
          v = v.toString().replace(/[.]/g, '');
        } else {
          c2 = '.';
          v = v.toString().replace(/[,]/g, '');
        }

        // Verifica se existe entrada nos inputs decimal e converte o value para validação
        if(v[v.indexOf(c2)] === ',') {
          v = v.replace(c2, c1);
        }

        // Verifica se possui range mínimo e máximo
        if (!isNaN(parseFloat(v)) && rangeMin && rangeMax) {
          if (v >= rangeMin && v <= rangeMax) return true
          return rangeErrorMessage ? rangeErrorMessage : returnMsgValidateRange['minAndMax']
        }

        // Verifica se possui somente range mínimo
        if (!isNaN(parseFloat(v)) && rangeMin) {
          if (v >= rangeMin) return true
          return rangeErrorMessage ? rangeErrorMessage : returnMsgValidateRange['min']
        }

        // Verifica se possui somente range máximo
        if (!isNaN(parseFloat(v)) && rangeMax) {
          if (v <= rangeMax) return true
          return rangeErrorMessage ? rangeErrorMessage : returnMsgValidateRange['max']
        }
       
        return 'Valores de validação não definido!';
      },
      validateTextWithoutSpecialCharacters: v => {
        return validateTextWithoutSpecialCharacters(v, this.allowedChars)
      },
      required,
      email,
      cpf,
      cpf_cnpj,
      cnpj,
      validateNumberInt,
      validateNumberInt16,
      validateNumberTinyInt,
      validatePercentage,
      validatePercentageWithoutNegative,
      validateIntegerPositive,
      validateIntegerNegative,
      validateNegativeValue,
      validatePositiveValue,
      validatePercentageLessThan100,

      allowedChars: [],
    };
  },

  computed: {
    rules() {
      const _vm = this;
      const { rules } = _vm.schema;

      if (!rules) return false;

      let allRules = [];

      rules.forEach(rule => {
        if (Array.isArray(rule)) {
          if (rule[0] in _vm && rule[0] === 'validateTextWithoutSpecialCharacters') {
            allRules.push(_vm[rule[0]])
            this.allowedChars = rule[1]
          }
        } else {
          rule in _vm && allRules.push(_vm[rule])
        }
      });

      return allRules;
    },
  },

  methods: {
    onBlur: function () {
      this.$emit('blur');
    },

    onChange: function () {
      this.$emit('change');
    },

    onFocus: function () {
      this.$emit('focus');
    },

    onInput: function () {
      this.$emit('input');
    }
  }
};

export default rulesMixin;
